import { LoadingButton } from "@mui/lab";
import {
  Box,
  Card,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { FormProvider } from "react-hook-form";
import UsersSearch from "src/components/autoComplete/users";
import { RHFSelect, RHFTextField } from "src/components/hook-form";
import Ternary from "src/components/ternary";
import { useTranslation } from "react-i18next";
import Translate from "src/components/translate";
import {
  getSelectedSymbol,
  useGetCurrencySymbol,
} from "src/components/with-prefix";
import { isMenuActive } from "src/utils/actionProtector";
import useAddForm from "./hooks/useAddForm";
import Users from "src/components/users";
import UsersList from "../../userList";
import DataFilter from "../data-table/components/dataFilter";
import DataTable from "../data-table";
import { useState } from "react";
import { capitalCase } from "change-case";

const genStatus = (gp, p) => {
  const test = isMenuActive(gp, p);
  return {
    add: test("add"),
  };
};

const FormFund = ({ method, state, fetchData, rowStart, ...rest }) => {
  const status = genStatus("Team");

  const { isDebit, methods, onSubmit } = useAddForm(fetchData);

  const {
    formState: { isSubmitting },
  } = methods;

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const buttonProps = {
    size: isSmallScreen ? "small" : "medium",
  };

  const { t } = useTranslation();
  const [data, setData] = useState(null);
  return (
    <Ternary
      when={status.add || status.deduct}
      then={
        <>
          <Grid container>
            <Grid item xs={12} lg={6} spacing={3}>
              <Card sx={{ p: 3 }}>
                <FormProvider {...methods}>
                  <Box
                    sx={{
                      display: "grid",
                      columnGap: 2,
                      rowGap: 5,
                      gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        sm: "repeat(2, 1fr)",
                      },
                      mb: 2,
                    }}
                  >
                    <UsersList
                      setData={setData}
                      name="user_id"
                      label="Search User"
                      props={{ size: "medium" }}
                      query="is_admin"
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      columnGap: 2,
                      rowGap: 3,
                      gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        sm: "repeat(2, 1fr)",
                      },
                      mb: 2,
                    }}
                  >
                    <UsersList
                      name="sponsor"
                      label="New Sponsor"
                      props={{ size: "medium" }}
                      query="is_admin"
                    />
                  </Box>

                  <Stack alignItems="flex-start" sx={{ mt: 3 }}>
                    <Box
                      sx={{
                        display: "grid",
                        columnGap: 2,
                        rowGap: 3,
                        gridTemplateColumns: "repeat(2, 1fr)",
                        mb: 2,
                      }}
                    >
                      <Ternary
                        when={status.add}
                        then={
                          <LoadingButton
                            {...buttonProps}
                            type="submit"
                            variant="contained"
                            onClick={methods.handleSubmit(onSubmit(true))}
                            name="deduct-amount"
                            loading={isDebit && isSubmitting}
                          >
                            Update{" "}
                          </LoadingButton>
                        }
                      />
                    </Box>
                  </Stack>
                </FormProvider>
              </Card>
            </Grid>
            <Grid xs={12} lg={6}>
              {data && (
                <>
                  <Stack spacing={2} p={2}>
                    <Typography variant="subtitle1">
                      User Information
                    </Typography>

                    <InfoRow
                      label="Full Name"
                      value={`${
                        data?.user_profile?.user_profile?.first_name || ""
                      } ${data?.user_profile?.user_profile?.last_name || ""}`}
                    />
                    <InfoRow
                      label="Email"
                      value={data?.user_profile?.email || "N/A"}
                    />
                    <InfoRow
                      label="User Type"
                      value={capitalCase(
                        data?.user_profile?.user_type || "N/A"
                      )}
                    />
                    <InfoRow
                      label="Current Sponsor"
                      value={data?.sponsor_info?.username || "N/A"}
                    />
                  </Stack>
                </>
              )}
            </Grid>
          </Grid>

          {/* <Card sx={{ p: 2, mt: 2 }}>
            {" "}
            <DataFilter methods={method} fetchData={fetchData} />
          </Card> */}
          <DataTable
            state={state}
            fetchData={fetchData}
            rowStart={rowStart}
            {...rest}
          />
        </>
      }
    />
  );
};
const InfoRow = ({ label, value }) => (
  <Box display="flex" alignItems="center">
    <Typography variant="subtitle2" sx={{ fontWeight: 600, width: 150 }}>
      {label}:
    </Typography>
    <Typography variant="body1">{value}</Typography>
  </Box>
);
export default FormFund;
